module.exports = __webpack_public_path__ + "static/media/calendar.949701ba.svg";